import type { Animation, Hierarchy } from '@adflow/types';

export type CanvasElementLayout = {
  id: string;
  x: number;
  y: number;
  z: number;
};

export type CanvasDocumentState = {
  elements: CanvasElementLayout[];
  animation: Animation | null;
  hierarchy: Hierarchy | null;
};

export type EditorSessionState = {
  viewport: { panX: number; panY: number; zoom: number };
  selection: { selectedIds: string[]; enteredGroupId: string | null };
  playheadSeconds: number;
};

export function getElementLayout(
  document: CanvasDocumentState,
  elementId: string,
): CanvasElementLayout | undefined {
  return document.elements.find((element) => element.id === elementId);
}

export function cloneDocument(document: CanvasDocumentState): CanvasDocumentState {
  return structuredClone(document);
}
